"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeArea = exports.savePracticeAreas = exports.removeAvatar = exports.addAvatar = exports.uploadAvatar = exports.deleteAccount = exports.createProfile = exports.updateProfile = exports.userFormChange = exports.toggleProfileEdit = exports.setProfileForm = exports.resetPracticeAreas = exports.setFormUpdate = exports.toggleEdit = exports.setErrorMessage = exports.toggleSuccessModal = exports.togglePracticeAreasModal = exports.changePracticeArea = exports.resetState = exports.toggleAvatarLoading = exports.setApiError = exports.validateAddress = exports.validateInputs = exports.profileFormChange = exports.setPracticeAreas = exports.setForm = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const pick_1 = __importDefault(require("lodash/pick"));
const omit_1 = __importDefault(require("lodash/omit"));
const store_1 = __importDefault(require("../store"));
const lawFirmSlice_1 = require("./lawFirmSlice");
const api_1 = require("../../services/api");
const validator_1 = require("../../widgets/lawFirmProfile/validator");
const common_1 = require("../../utils/common");
const userSlice_1 = require("./userSlice");
const initialState = {
    editState: false,
    avatarLoading: false,
    errorMessage: '* Please fill in all required fields.',
    formData: {
        id: 0,
        firm_name: '',
        imageUrl: '',
        bio: '',
        name: '',
        email: '',
        contact_person: '',
        additional_phone: '',
        website: '',
        full_address: {
            street: '',
            city: '',
            state_id: 0,
            zip_code: '',
            state_abbrev: '',
        },
        attorneys_range: 0
    },
    formValid: true,
    addressValid: true,
    validationFields: {
        formValid: null,
        firmNameValid: null,
        emailValid: null,
        nameValid: null,
        contactPersonValid: null,
        additionalPhoneValid: null,
        bioValid: true,
        websiteValid: null,
        zipCodeValid: null
    },
    apiErrors: {
        emailRegistered: null
    },
    practiceArea: {
        static: {
            changes: [],
            old: [],
            changed: false,
        },
        temp: {
            changes: [],
            old: [],
            changed: false,
        }
    },
    practiceAreaModal: false,
    formUpdated: false,
    successModal: false
};
const lawFirmProfile = toolkit_1.createSlice({
    name: 'lawFirmProfile',
    initialState: initialState,
    reducers: {
        setForm: (state, action) => {
            const data = pick_1.default(action.payload, Object.keys(initialState.formData));
            state.formData = data;
            return state;
        },
        setPracticeAreas: (state, action) => {
            if (action.payload.areas) {
                state.practiceArea.static.old = action.payload.areas;
                state.practiceArea.temp.old = action.payload.areas;
                return state;
            }
        },
        profileFormChange: (state, action) => {
            const data = action.payload;
            if (data.field.includes('full_address')) {
                const field = /\[([^)]*)]/.exec(data.field)[1]; // reg-ex to get property from string
                state.formData.full_address[field] = data.value;
            }
            else {
                state.formData[data.field] = data.value;
            }
            state.formUpdated = validator_1.hasChangedForm(state.formData, data.user);
            return state;
        },
        setFormUpdate: (state = initialState) => {
            state.formUpdated = true;
            return state;
        },
        validateInputs: (state, action) => {
            if (Array.isArray(action.payload)) {
                action.payload.forEach((el => {
                    state.validationFields = validator_1.profileFormValidator(state.validationFields, el);
                }));
            }
            else {
                state.validationFields = validator_1.profileFormValidator(state.validationFields, action.payload);
            }
            state.formValid = Object.keys(state.validationFields).every(k => state.validationFields[k] !== false);
            state.errorMessage = initialState.errorMessage;
            return state;
        },
        setApiError: (state, action) => {
            state.apiErrors[action.payload.field] = action.payload.status;
        },
        validateAddress: (state) => {
            state.addressValid = validator_1.addressValidator(state.formData.full_address);
            return state;
        },
        toggleAvatarLoading: (state) => {
            state.avatarLoading = !state.avatarLoading;
            return state;
        },
        toggleEdit: (state) => {
            state.editState = !state.editState;
            return state;
        },
        resetState: (state) => {
            state.editState = initialState.editState;
            state.formValid = initialState.formValid;
            state.formData = initialState.formData;
            state.validationFields = initialState.validationFields;
            state.errorMessage = initialState.errorMessage;
            state.addressValid = initialState.addressValid;
            state.formUpdated = false;
            return state;
        },
        changePracticeArea: (state = initialState, action) => {
            if (action.payload.static) {
                state.practiceArea.static = action.payload.static;
            }
            else if (action.payload.temp) {
                state.practiceArea.temp = action.payload.temp;
            }
            return state;
        },
        togglePracticeAreasModal: (state) => {
            if (!state.practiceArea.temp.changed) {
                state.practiceArea.temp.changes = [];
            }
            state.practiceAreaModal = !state.practiceAreaModal;
            return state;
        },
        toggleSuccessModal: (state) => {
            state.successModal = !state.successModal;
            return state;
        },
        setErrorMessage: (state, action) => {
            state.errorMessage = action.payload || initialState.errorMessage;
            state.formValid = false;
            return state;
        },
        resetPracticeAreas: (state = initialState) => {
            state.practiceArea = {
                static: {
                    changes: [],
                    old: state.practiceArea.static.old,
                    changed: false,
                },
                temp: {
                    changes: [],
                    old: state.practiceArea.static.old,
                    changed: false,
                }
            };
            return state;
        }
    }
});
_a = lawFirmProfile.actions, exports.setForm = _a.setForm, exports.setPracticeAreas = _a.setPracticeAreas, exports.profileFormChange = _a.profileFormChange, exports.validateInputs = _a.validateInputs, exports.validateAddress = _a.validateAddress, exports.setApiError = _a.setApiError, exports.toggleAvatarLoading = _a.toggleAvatarLoading, exports.resetState = _a.resetState, exports.changePracticeArea = _a.changePracticeArea, exports.togglePracticeAreasModal = _a.togglePracticeAreasModal, exports.toggleSuccessModal = _a.toggleSuccessModal, exports.setErrorMessage = _a.setErrorMessage, exports.toggleEdit = _a.toggleEdit, exports.setFormUpdate = _a.setFormUpdate, exports.resetPracticeAreas = _a.resetPracticeAreas;
const setProfileForm = () => async (dispatch, getState) => {
    const user = getState().lawFirm.user;
    await dispatch(exports.setForm(user));
    dispatch(exports.validateAddress());
};
exports.setProfileForm = setProfileForm;
const toggleProfileEdit = () => async (dispatch, getState) => {
    await dispatch(exports.toggleEdit());
    const editState = getState().lawFirmProfile.editState;
    editState && dispatch(exports.setProfileForm());
};
exports.toggleProfileEdit = toggleProfileEdit;
const userFormChange = (data) => async (dispatch, getState) => {
    const user = getState().lawFirm.user;
    dispatch(exports.profileFormChange(Object.assign(Object.assign({}, data), { user })));
    window.AppearMe.Widgets.Events.emit('onUserChange', { hide: false });
};
exports.userFormChange = userFormChange;
const updateProfile = (data, practiceArea) => async (dispatch, getState) => {
    try {
        const { formValid, addressValid } = getState().lawFirmProfile;
        if (formValid && addressValid) {
            const res = await api_1.LawFirm.updateAccount(omit_1.default(Object.assign(Object.assign({}, data), { updatedAreas: practiceArea.temp.changes }), ['id']));
            await dispatch(lawFirmSlice_1.getLawFirmUser(res.id));
            api_1.Auth.updateAngularUser();
            dispatch(exports.toggleEdit());
            localStorage.removeItem('profile_changed');
        }
        else {
            common_1.scrollToElemError();
        }
    }
    catch (e) {
        // TODO: make some global error note in future
        console.log("e", e);
        if (e.code === 400) {
            dispatch(exports.setApiError({ field: 'emailRegistered', status: true }));
            dispatch(exports.setErrorMessage());
        }
    }
};
exports.updateProfile = updateProfile;
const createProfile = () => async (dispatch, getState) => {
    try {
        let { formData, formValid, addressValid } = getState().lawFirmProfile;
        if (formValid && addressValid) {
            await api_1.LawFirm.updateAccount(Object.assign(Object.assign({}, formData), { activated: 1, activation_date: new Date().toJSON() }));
            dispatch(exports.toggleSuccessModal());
            dispatch(exports.resetState());
            window.AppearMe.Widgets.Events.emit('onUserCreate', {});
        }
        else {
            setTimeout(() => common_1.scrollToElemError(), 50);
        }
    }
    catch (e) {
        // TODO: make some global error note in future
        console.log("e", e);
    }
};
exports.createProfile = createProfile;
const deleteAccount = () => async (dispatch) => {
    const lfId = store_1.default.getState().lawFirmProfile.formData.id;
    try {
        const res = await api_1.LawFirm.deleteAccount(lfId);
        if (res.deleted) {
            window.AppearMe.Widgets.Events.emit('onUserChange', { hide: true });
            return window.location.href = '#/logout';
        }
        else {
            dispatch(exports.setErrorMessage('* Please delete or complete your requests before you delete your account.'));
        }
    }
    catch (e) {
        // TODO: make some global error note in future
        console.log("error", e);
    }
};
exports.deleteAccount = deleteAccount;
const uploadAvatar = (data) => async (dispatch) => {
    try {
        dispatch(exports.toggleAvatarLoading());
        const payload = await api_1.Auth.upload('file', data);
        const imageData = { imageUrl: `https://s3.amazonaws.com/findalawyer/${payload.data.files[0].fd}` };
        const res = await api_1.LawFirm.updateAccount(imageData);
        await dispatch(lawFirmSlice_1.getLawFirmUser(res.id));
        dispatch(exports.toggleAvatarLoading());
        api_1.Auth.updateAngularUser('image');
    }
    catch (e) {
        dispatch(userSlice_1.avatarError(e));
    }
};
exports.uploadAvatar = uploadAvatar;
const addAvatar = (data) => async (dispatch) => {
    dispatch(exports.toggleAvatarLoading());
    const payload = await api_1.Auth.upload('file', data);
    const imageData = `https://s3.amazonaws.com/findalawyer/${payload.data.files[0].fd}`;
    dispatch(exports.userFormChange({ value: imageData, field: 'imageUrl' }));
    dispatch(exports.toggleAvatarLoading());
};
exports.addAvatar = addAvatar;
const removeAvatar = (data) => async (dispatch) => {
    try {
        dispatch(exports.toggleAvatarLoading());
        const res = await api_1.LawFirm.updateAccount({ imageUrl: null });
        await api_1.Auth.delete('/deleteFileFromS3', { params: { userImage: data.imageUrl } });
        await dispatch(lawFirmSlice_1.getLawFirmUser(res.id));
        dispatch(exports.toggleAvatarLoading());
        api_1.Auth.updateAngularUser('image');
    }
    catch (e) {
        dispatch(userSlice_1.avatarError(e));
    }
};
exports.removeAvatar = removeAvatar;
const savePracticeAreas = (data, id) => async (dispatch) => {
    if (data.temp.changed) {
        await api_1.LawFirm.updatePracticeAreas({ updatedAreas: data.temp.changes });
        await dispatch(lawFirmSlice_1.getLawFirmUser(id));
        dispatch(exports.resetPracticeAreas());
    }
};
exports.savePracticeAreas = savePracticeAreas;
const changeArea = (data, type = 'temp', deleted) => async (dispatch) => {
    dispatch(exports.changePracticeArea({ [type]: data }));
    if (deleted) {
        await api_1.LawFirm.updatePracticeAreas({ updatedAreas: data.changes });
    }
};
exports.changeArea = changeArea;
exports.default = lawFirmProfile.reducer;
